import React from 'react';

import TitleBar from 'shared/migration-components/title-bar';

import {Container} from './styles';
import Tabs, {TabProps} from 'shared/migration-components/tabs';
import {Additionals, EditAdditionalGroup} from './components';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

interface Props {
  activeTab?: string;
}

const CompanyDetails: React.FC<Props> = ({activeTab}) => {
  const {isAllowed} = useAccessControls();

  const tabs: TabProps[] = [
    {
      label: 'Editar',
      content: <EditAdditionalGroup />,
      hidden: !isAllowed('additionalGroups.findOne'),
    },
    {
      tab: 'additionals',
      label: 'Adicionais',
      content: <Additionals />,
      hidden: !isAllowed('additionalGroups.findOne'),
      createUrl: 'create',
    },
  ];

  return (
    <Container>
      <TitleBar
        title="Detalhes do grupo de adicionais"
        backUrl="/menu/additional-groups"
      />
      <Tabs {...{activeTab, tabs}} />
    </Container>
  );
};

export default CompanyDetails;
